import Bellefont101 from './Bellefont 10 (1).webp'
import Bellefont102 from './Bellefont 10 (2).webp'


const Bellefont10images =[
Bellefont101,Bellefont102
]

export default Bellefont10images;